import { createAccessDecision } from './records/AccessDecision';

export const allowDecision = () => createAccessDecision({ isAllowed: true });
